module.exports = __webpack_public_path__ + "img/active2.22a96dc0.png";